export default __webpack_public_path__ + "static/media/082-united-nations.7c644f25.svg";